export default __webpack_public_path__ + "static/media/logo-cetic.edbea55e.png";